module.exports = __webpack_public_path__ + "media/my_images/top/wave-9a29fe1ce15881b29a471f94ce27d8ed.svg";